import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{attrs:{"to":_vm.to}},[_c(VCardTitle,{staticClass:"primary--text"},[_vm._v(_vm._s(_vm.title))]),_c(VCardSubtitle,[_vm._v(_vm._s(_vm.subtitle))]),_c(VCardText,{staticClass:"text-center"},[_c(VIcon,{staticClass:"primary--text",attrs:{"size":"100"}},[_vm._v(_vm._s(_vm.icon))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }